import { InputWrapper, LabelText } from 'src/comps/Atom/Inputs/Input/styles'
import styled, { css } from 'styled-components'

interface SuggesterBorderLessWrapperProps {
  hasFocus: boolean
  hasError: boolean
}

export const SuggesterBorderLessWrapper = styled.div<SuggesterBorderLessWrapperProps>`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
  padding-block: 6px;
  padding-inline: 8px;
  background: ${props => props.theme.colors.grey8};
  border-radius: 100px;
  border: 2px solid transparent;

  ${InputWrapper} {
    width: 100%;
    padding-block: 0;
    padding-inline: 0;
    border: none;
    background: none;
    height: 28px;
    inset-inline-end: 8px;

    ${LabelText} {
      display: none;
    }

    &:hover {
      border: none;
    }

    input {
      padding-block: 0;
      padding-inline: 0;
      padding-inline-start: 5px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: calc(100% - 16px);
    }
  }

  &:hover {
    background: var(--color--neutral--300);
  }

  ${({ hasError }) =>
    hasError &&
    css`
      color: var(--color--semantic--error--500);
      background: var(--color--semantic--error--100);
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%;

      :hover {
        background: var(--color--semantic--error--100);
      }

      & input::placeholder {
        color: var(--color--semantic--error--500);
      }

      & svg {
        fill: var(--color--semantic--error--500);
      }
    `}
`
